import { Component, Input, OnInit, NgZone } from '@angular/core';
import { Labels } from './../../app.models';
import { DialogService } from '../../services/dialog.service';
import { EternalLinkDialogComponent } from '../external-link-dialogs/external-link-dialog.component';
import { UtilsService } from '../../services/utils.service';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent implements OnInit {
  tacLabels!: any;
  agreement!: string;
  isMobile$: Observable<boolean>;
  @Input() flow!: string;
  @Input() locale!: string;
  flowType: string;

  public _labels: any;
  @Input() public set labels(labels: Labels) {
    this._labels = labels;
    this.tacLabels = labels?.stellar?.termsAndConditions;
  }
  public get labels() {
    return this._labels;
  }

  constructor(
    private dialogService: DialogService,
    private utilsService: UtilsService,
    private zone: NgZone
  ) {}

  ngOnInit(): void {
    this.isMobile$ = this.utilsService.isMobile;
    this.agreement = this.getUpdateUrl(this.tacLabels.mgAgreementPara3.web);
    this.flowType = this.flow === 'deposit' ? 'cashIn' : 'cashOut';
  }

  //Method that will update the url for web and mobile view
  getUpdateUrl(url: string) {
    return url.replace('%s1', 'us').replace('%s2', 'en');
  }

  // This method checks if a string begins with a '.' and adds a &nbsp; [space] if it does not.
  beginsWithPeriod(str: string | undefined) {
    if (!str) return;
    if (str[0] === '.') {
      return '';
    }
    return ' ';
  }

  beginsWithComma(str: string | undefined) {
    if (!str) return;
    if (str[0] === ',') {
      return '';
    }
    return ' ';
  }

  // For French translations, the "l’" article should not have a space after it.
  checkFrenchArticle(str: string | undefined) {
    if (str && str[str.length - 1] === '’') {
      return '';
    }
    return ' ';
  }

  openDialog(Url: string) {
    const url = this.getUpdateUrl(Url);
    this.zone.run(() => {
      this.dialogService.open(EternalLinkDialogComponent, {
        data: {
          url,
        },
        ariaLabel: 'title',
        role: 'alertdialog',
      });
    });
    return false;
  }
}
